import React, { useState } from 'react';
import { Link } from "react-router-dom";

function NewSurveyForm(props) {
    const [surveyTitle, updateSurveyTitle] = useState("New Survey");
    const toRedirectScratch = {pathname: "/survey/builder", state: {surveyName: surveyTitle}};

    function onSurveyTitleClick(event) {
        if (event.target.value === "New Survey") {
            event.target.select();
        }
    }

    function onSurveyTitleChange(event) {
        const surveyTitle = event.target.value;
        updateSurveyTitle(surveyTitle);
    }

    return (
        <React.Fragment>
            <span className="close" onClick={props.closeModal}>&times;</span>
            <div className="modal-content__title modal-content__title--center">Create survey</div>
            <div className="modal-content__inputs">
                <input type="text" value={surveyTitle} placeholder="Name your survey" onClick={onSurveyTitleClick} onChange={onSurveyTitleChange} />
            </div>
            <div className="modal-content__actions modal-content__actions--center pb-xl">
                <Link className="modal-content__actions__btn modal-content__actions__btn--filledBlue" to={toRedirectScratch}>Start from scratch</Link>
                <Link className="modal-content__actions__btn modal-content__actions__btn--filledGreen" to="/survey-templates">Start from template</Link>
            </div>
        </React.Fragment>
    );
}

export default NewSurveyForm;